applications.classy.controller({
    name: 'NoteController',
    inject: ['$scope', '$location', 'ApplicationService', 'ApplicationsSubNavbarService', 'FirstRunModalService',
        '$stateParams', 'AlertService', 'CSNotesModelService', 'BinFactory', '$timeout', '$rootScope', 'authServiceFactory', '$http', 'TabsService'],
    init: function() {
        this.$.CSNotesModelService = this.CSNotesModelService;
        if (this.authServiceFactory.getAuth().isISM) {
            this.$.notes = this.CSNotesModelService.get(this.authServiceFactory.getAuth().schoolID);
            this.$.newNote = this.CSNotesModelService.new();
        }
    },
    watch:
    {
        'this.ApplicationService.getOpenNote()': function() {
            if (this.ApplicationService.getOpenNote()==true) {
                this.$.notes = this.CSNotesModelService.get(this.authServiceFactory.getAuth().schoolID);
            }
        }
    },
    addNote: function(form) {
        if (form.$valid) {
            var parent = this;
            if (this.$.newNote.recordID==undefined) {
                this.CSNotesModelService.post(this.authServiceFactory.getAuth().schoolID, this.$.newNote).then(function (response) {
                    //parent.$.notes = parent.CSNotesModelService.get(parent.authServiceFactory.getAuth().schoolID);
                    parent.$.newNote.recordID = response.data.id;
                    parent.$.notes.push(parent.$.newNote);
                    parent.$.newNote = parent.CSNotesModelService.new();
                });
            }
            else {
                this.CSNotesModelService.put(this.authServiceFactory.getAuth().schoolID, this.$.newNote).then(function (response) {
                    //parent.$.notes = parent.CSNotesModelService.get(parent.authServiceFactory.getAuth().schoolID);
                    parent.$.newNote = parent.CSNotesModelService.new();
                });
            }
        }
    },
    editNote: function(index) {
        this.$.newNote = this.$.notes[index];
    },
    deleteNote: function(index) {
        this.$.newNote = this.CSNotesModelService.new();
        var parent = this;
        this.$.notes[index].deleted = 1;
        this.CSNotesModelService.put(this.authServiceFactory.getAuth().schoolID, this.$.notes[index]).then(function (response) {
            
        });
    }

});
